<br />
<form [formGroup]="vehicleForm" (ngSubmit)="handleSubmit($event)">
    <div class="row">
        <mat-form-field class="col" appearance="fill">
            <mat-label>Vin</mat-label>
            <mat-placeholder>123456789ABCDEFGH</mat-placeholder>
            <input class="form-control" type="text" matInput formControlName="vin" maxlength="18" minlength="5" />
            <mat-error>Invalid Vin</mat-error>
        </mat-form-field>

        <mat-form-field class="col" appearance="fill">
            <mat-label>Stock Number</mat-label>
            <mat-placeholder>Stock Number</mat-placeholder>
            <input class="form-control" type="text" matInput formControlName="stockNumber" />
            <mat-error>Invalid Stock Number</mat-error>
        </mat-form-field>
    </div>

    <div class="row">
        <mat-form-field class="col" appearance="fill">
            <mat-label>Price</mat-label>
            <mat-placeholder>10000</mat-placeholder>
            <input class="form-control" type="number" matInput formControlName="price" />
            <mat-error>Invalid Price</mat-error>
        </mat-form-field>
        <mat-form-field class="col" appearance="fill">
            <mat-label>Payoff Amount</mat-label>
            <mat-placeholder>10000</mat-placeholder>
            <input class="form-control" type="number" matInput formControlName="payoff" />
            <mat-error>Invalid Payoff Amount</mat-error>
        </mat-form-field>
    </div>

    <div class="row">
        <mat-form-field class="col" appearance="fill">
            <mat-label>Year</mat-label>
            <mat-placeholder>2022</mat-placeholder>
            <input class="form-control" type="number" matInput formControlName="year" />
            <mat-error>Invalid Year</mat-error>
        </mat-form-field>
        <mat-form-field class="col" appearance="fill">
            <mat-label>Make</mat-label>
            <mat-placeholder>Make</mat-placeholder>
            <input class="form-control" type="text" matInput formControlName="make" />
            <mat-error>Invalid Make</mat-error>
        </mat-form-field>
        <mat-form-field class="col" appearance="fill">
            <mat-label>Model</mat-label>
            <mat-placeholder>Model</mat-placeholder>
            <input class="form-control" type="text" matInput formControlName="model" />
            <mat-error>Invalid Model</mat-error>
        </mat-form-field>
    </div>

    <div class="row">
        <mat-form-field class="col" appearance="fill">
            <mat-label>Trim</mat-label>
            <mat-placeholder>Trim</mat-placeholder>
            <input class="form-control" type="text" matInput formControlName="trim" />
            <mat-error>Invalid Trim</mat-error>
        </mat-form-field>

        <mat-form-field class="col" appearance="fill">
            <mat-label>Body Style</mat-label>
            <mat-placeholder>Body Style</mat-placeholder>
            <input class="form-control" type="text" matInput formControlName="bodyStyle" />
            <mat-error>Invalid Body Style</mat-error>
        </mat-form-field>
    </div>

    <div class="row">
        <mat-form-field class="col" appearance="fill">
            <mat-label>Interior Color</mat-label>
            <mat-placeholder>Interior Color</mat-placeholder>
            <input class="form-control" type="text" matInput formControlName="interiorColor" />
            <mat-error>Invalid Interior Color</mat-error>
        </mat-form-field>

        <mat-form-field class="col" appearance="fill">
            <mat-label>Exterior Color</mat-label>
            <mat-placeholder>Exterior Color</mat-placeholder>
            <input class="form-control" type="text" matInput formControlName="exteriorColor" />
            <mat-error>Invalid Exterior Color</mat-error>
        </mat-form-field>
    </div>
</form>
